import Component from '../../common/Component';
import Avatar from '../../common/components/Avatar';
import classList from '../../common/utils/classList';
/**
 * The `LoadingPost` component shows a placeholder that looks like a post,
 * indicating that the post is loading.
 */
export default class LoadingPost extends Component {
  view() {
    return m("div", {
      className: classList(this.attrs.className, 'Post CommentPost LoadingPost')
    }, m("header", {
      className: "Post-header"
    }, m(Avatar, {
      user: null,
      className: "PostUser-avatar"
    }), m("div", {
      className: "fakeText"
    })), m("div", {
      className: "Post-body"
    }, m("div", {
      className: "fakeText"
    }), m("div", {
      className: "fakeText"
    }), m("div", {
      className: "fakeText"
    })));
  }
}
flarum.reg.add('core', 'forum/components/LoadingPost', LoadingPost);